export const homeObjOne = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: "",
  headline: "Lead Generation Specialist for Online Businesses",
  description:
    "Limited: 1,500 unique, fruity, algorithmically generated Bananas - stored with proof of ownership on the Solana blockchain",
  buttonLabel: "Get Started",
  imgStart: "",
  img: "https://solanamonkey.business/images/gen2.png",
  alt: "",
  start: "",
};

export const homeObjTwo = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: "",
  headline: "UTILITY & ROADMAP",
  description:
    "Access to the academy means more than just bragging rights to those uneducated, less sophisticated apes. We have made it our goal to make sure utility is always offered to all our students. This utility will be modest at first but will expand over time as we continue to build We are building the academy not just for you, but also with you. Click below to see our roadmap for the near and longer term future We hope you have your crayons ready..",
  buttonLabel: "VISIT ROADMAP",
  imgStart: "",
  img: "https://images.unsplash.com/photo-1592111332908-f8f7fe1bb041?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8cm9hZG1hcHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
  alt: "Vault",
  start: "",
  
};

export const homeObjThree = {
  primary: false,
  lightBg: true,
  lightTopLine: false,
  lightText: false,
  lightTextDesc: false,
  topLine: "",
  headline: "ABOUT DAO ",
  description:
    "The academy was founded on the principles of friendship making, crayon eating and absolute, unregulated, deplorable, degenerate behaviour. Welcome fellow apes, to the Degenerate Ape Academy. We believe in Doalana and we believe in NFTs. In the future, we'll look at this period as a defining moment in culture and technology. History is being made, and we want to be part of it in a meaningful way.",
  buttonLabel: "",
  imgStart: "start",
  img: "https://www.degenape.academy/static/media/pc-off.f0b9d8a6.png",
  alt: "Vault",
  start: "true",
};

